/**
 * Add to Cart Component
 * Handles adding products to cart with loading states
 * 
 * @requires ThemeUtils (utils.js) - optional
 */

class AddToCart {
  /**
   * Add item to cart via Shopify AJAX API
   * @param {FormData} formData - Form data with id and quantity
   * @returns {Promise<{success: boolean, item?: object, error?: Error}>}
   */
  static async addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Failed to add to cart');
      }
      
      const item = await response.json();
      
      // Dispatch product added event
      if (window.ThemeUtils?.dispatchEvent) {
        window.ThemeUtils.dispatchEvent('product:added', { item });
      } else {
        window.dispatchEvent(new CustomEvent('product:added', { detail: { item } }));
      }
      
      // Open cart drawer
      const cartButton = document.querySelector('[data-drawer-toggle="cart"]');
      if (cartButton) cartButton.click();
      
      return { success: true, item };
    } catch (error) {
      return { success: false, error };
    }
  }

  /**
   * Handle form submission
   * @param {Event} event - Submit event
   * @param {HTMLElement} button - Submit button element
   */
  static async handleSubmit(event, button) {
    event.preventDefault();
    
    const originalText = button.innerHTML;
    const addingText = button.dataset.addingText || window.theme?.strings?.adding || '';
    button.innerHTML = `<span class="loading-spinner"></span> ${addingText}`;
    button.disabled = true;

    let formData;
    if (event.target.tagName === 'FORM') {
      formData = new FormData(event.target);
    } else {
      formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', 1);
    }

    const result = await this.addToCart(formData);

    if (result.success) {
      const addedText = button.dataset.addedText || window.theme?.strings?.added || '';
      button.innerHTML = `<span>${addedText}</span>`;
    } else {
      const errorText = button.dataset.errorText || window.theme?.strings?.errorTryAgain || '';
      button.innerHTML = errorText;
    }

    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 2000);
  }
}

window.AddToCart = AddToCart;